import { Box, BoxProps } from '@mui/material';
import jsonExport from 'jsonexport/dist';
import { Fragment, memo, MouseEvent, useState } from 'react';
import {
  BooleanField,
  BulkDeleteButton,
  BulkDeleteButtonProps,
  BulkExportButton,
  BulkExportButtonProps,
  Datagrid,
  DateField,
  downloadCSV,
  EditButton,
  List,
  ReferenceManyField,
  ShowButton,
  ShowView,
  SimpleShowLayout,
  TextField,
  TextInput,
  useDataProvider,
  useRecordContext
} from 'react-admin';

const OrganizationsListActionToolbar = (props: BoxProps) => <Box sx={{ alignItems: 'center', display: 'flex' }}>{props.children}</Box>;
const OrganizationsListBulkActions = memo((props: BulkDeleteButtonProps & BulkExportButtonProps) => (
  <Fragment>
    <BulkDeleteButton {...props} />
    <BulkExportButton {...props} />
  </Fragment>
));
const exporter = (users: any[]) => {
  return jsonExport(users, (err: Error, csv: string) => downloadCSV(csv, 'users'));
};
const rowClick = (id: unknown, resource: unknown, record: any) => {
  if (record.commentable) {
    return 'edit';
  }
  return 'show';
};
const OrganizationsPanel = () => {
  return (
    <ShowView>
      <SimpleShowLayout>
        <TextField source="id" />
        <TextField source="uuid" />
        <TextField source="name" />
        <TextField source="encryptedVerificationToken" />
        <TextField source="vendor" />
        <TextField source="model" />
        <TextField source="verificationSms" />
        <TextField source="user" />
        <TextField source="firebaseToken" />
        <DateField source="migratedAt" sortByOrder="DESC" />
        <BooleanField source="phoneNumberValid" />
        <TextField source="originalPhoneNumber" />
        <TextField source="appVersion" />
        <DateField source="createdAt" sortByOrder="DESC" />
        <DateField source="updatedAt" sortByOrder="DESC" />
      </SimpleShowLayout>
    </ShowView>
  );
};

//const usersFilter = [<SearchInput source="fullName" alwaysOn />, <TextInput source="company" defaultValue="" />, <TextInput source="id" defaultValue="" />, <TextInput source="uuid" defaultValue="" />];
const usersFilter = [<TextInput label="Name" source="name" alwaysOn />, <TextInput label="Uuid" source="uuid" alwaysOn />];

const SyncButton = () => {
  const record = useRecordContext();
  const dataProvider = useDataProvider();
  const [loading, setLoading] = useState(false);
  return (
    <Box
      component="button"
      disabled={loading}
      type="button"
      sx={{
        outline: 'none',
        background: 'transparent',
        border: 'none',
        color: loading ? 'text.disabled' : 'primary.main',
        cursor: 'pointer'
      }}
      onClick={(event: MouseEvent) => {
        event.stopPropagation();
        setLoading(true);
        dataProvider.syncOrganisation(record.uuid).finally(() => setLoading(false));
      }}
    >
      {loading ? 'Loading' : 'SYNC'}
    </Box>
  );
};

const OrganizationsList: React.FC = () => {
  return (
    <List filters={usersFilter} sort={{ field: 'id', order: 'DESC' }} exporter={exporter}>
      <Datagrid bulkActionButtons={<OrganizationsListBulkActions />} rowClick={rowClick} expand={OrganizationsPanel} optimized sx={{ image: { maxHeight: '1rem' } }}>
        <TextField source="id" />
        <TextField source="uuid" />
        <TextField source="name" />
        <ReferenceManyField reference="companies" target="organizationId">
          <Datagrid>
            <TextField source="uuid" />
          </Datagrid>
        </ReferenceManyField>
        <DateField source="createdAt" sortByOrder="DESC" />
        <DateField source="updatedAt" sortByOrder="DESC" />
        <OrganizationsListActionToolbar>
          <SyncButton />
          <EditButton />
          <ShowButton />
        </OrganizationsListActionToolbar>
      </Datagrid>
    </List>
  );
};

export default OrganizationsList;
